import type { AxiosRequestConfig, AxiosResponse } from 'axios';

import client from 'api/client';
import type { DocumentTemplateRecord, ListDocumentTemplatesParams } from 'types/servicesDocuments';

export const listDocumentTemplates = (
    params?: ListDocumentTemplatesParams,
    customConfig?: AxiosRequestConfig
): Promise<AxiosResponse<DocumentTemplateRecord[]>> => {
    return client.get<DocumentTemplateRecord[]>('/document-templates', {
        ...customConfig,
        params: {
            ...(customConfig?.params || {}),
            ...(params || {}),
        },
    });
};

/** @deprecated Prefer `listDocumentTemplates` — kept for organization document flows. */
export const getClientCompanyDocumentTemplates = (clientOrgId?: string) => {
    return listDocumentTemplates(
        clientOrgId ? { has_been_requested_from_organization_id: clientOrgId } : undefined
    );
};

export const createDocumentTemplate = (payload: FormData) => {
    return client.post<DocumentTemplateRecord>('/document-templates', payload, {
        headers: { 'Content-Type': 'multipart/form-data' },
    });
};

export const updateDocumentTemplate = (documentTemplateId: number, payload: FormData) => {
    return client.patch<DocumentTemplateRecord>(
        `/document-templates/${documentTemplateId}`,
        payload,
        {
            headers: { 'Content-Type': 'multipart/form-data' },
        }
    );
};

export const deleteDocumentTemplate = (documentTemplateId: number) => {
    return client.delete<DocumentTemplateRecord>(`/document-templates/${documentTemplateId}`);
};

export const getDocumentTemplatePreviewUrl = (documentTemplateId: number) => {
    return client.get(`/document-templates/${documentTemplateId}/template_uri`);
};

export const getDocumentTemplateSamplePreviewUrl = (documentTemplateId: number) => {
    return client.get(`/document-templates/${documentTemplateId}/sample_uri`);
};
